import { useMediaQuery } from "react-responsive";

const useMediaQueries = () => {
  const desktopCondition = useMediaQuery({ minWidth: 1200 });
  const largeDesktopCondition = useMediaQuery({ minWidth: 1400 });
  const leptopCondition = useMediaQuery({ minWidth: 1200, maxWidth: 1400 });
  const horizontalTabletCondition = useMediaQuery({
    minWidth: 1024,
    maxWidth: 1200,
  });
  const mobileCondition = useMediaQuery({ maxWidth: 769 });
  const tabletCondition = useMediaQuery({ minWidth: 770, maxWidth: 1200 });

  // forms using, do not remove until all forms are refactored
  const notMobile = useMediaQuery({ minWidth: 1024 });
  const newMobileCondition = useMediaQuery({ maxWidth: 600 });
  const newTabletCondition = useMediaQuery({ minWidth: 750, maxWidth: 991 });

  const Desktop = ({ children }) => {
    return desktopCondition ? children : null;
  };
  const Tablet = ({ children }) => {
    return tabletCondition ? children : null;
  };
  const Mobile = ({ children }) => {
    return mobileCondition ? children : null;
  };

  const NoDesktop = ({ children }) => {
    return !desktopCondition ? children : null;
  };

  return {
    Desktop,
    Tablet,
    Mobile,
    NoDesktop,
    desktopCondition,
    largeDesktopCondition,
    tabletCondition,
    newTabletCondition,
    mobileCondition,
    newMobileCondition,
    leptopCondition,
    horizontalTabletCondition,
    notMobile,
  };
};

export default useMediaQueries;
